import * as msal from '@azure/msal-browser';

const msalConfig = {
	auth: {
		clientId: import.meta.env.VITE_MSAL_CLIENT_ID!,
		authority: import.meta.env.VITE_MSAL_AUTHORITY!,
		redirectUri: `${window.location.origin}`,
		postLogoutRedirectUri: 'https://www.wfp.org/',
	},
	cache: {
		cacheLocation: 'sessionStorage',
		storeAuthStateInCookie: true,
	},
};

const loginRequest = {
	scopes: ['User.Read'],
};

// Create the main msalApp instance
export const msalApp = (import.meta.env.NODE_ENV === "test") ? ({} as msal.PublicClientApplication) :
	new msal.PublicClientApplication(msalConfig);

export async function signIn() {
	if (import.meta.env.NODE_ENV !== "test") {  // prevent this from being used in tests
		await msalApp.loginRedirect(loginRequest);
	}
}

export function signOut() {
	return msalApp.logout();
}


let msalAccount: msal.AccountInfo | null = null;

export function setMsalAccount(account: msal.AccountInfo) {
	// this may be set from handleRedirectPromise, in this case msalApp.getAllAccounts would fail
	msalAccount = account;
}

export async function getTokenRedirect(request = loginRequest, account = null) {
	let requestAccount: msal.AccountInfo | null = account || msalAccount;
	if (requestAccount === null) {
		const accounts = await msalApp.getAllAccounts();
		if (accounts && accounts.length === 1) {
			requestAccount = accounts[0];
		}
	}
	if (!requestAccount) {
		await signIn();
		return null;
	}

	const req = {...request, account: requestAccount};

	const token = await msalApp.acquireTokenSilent(req).catch(error => {
		if (error instanceof msal.InteractionRequiredAuthError) {
			// fallback to interaction when silent call fails
			console.info('Silent token acquisition fails!');
			console.info('Acquiring token using redirect.');
			return msalApp.acquireTokenRedirect(request);
		}
		throw error;
	});

	return token;
}
